import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.13",
  "description": "Turborepo 1.13은 새롭고 개선된 로컬 개발 경험과 함께 기타 개선 사항을 제공합니다.",
  "date": "2024/03/21",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 1.13은 새롭고 개선된 로컬 개발 경험과 함께 기타 개선 사항을 제공합니다:"
  }, {
    "heading": "",
    "content": "새로운 터미널 UI : 향상된 터미널 경험에서 로컬로 작업과 상호 작용"
  }, {
    "heading": "",
    "content": "가장 빠른 기본값 활성화: turbo scan으로 로컬 개발 환경을 더 빠르게 만들기"
  }, {
    "heading": "",
    "content": "CI 로깅 개선: 4개 주요 제공업체 지원 및 오류 작업 자동 펼치기"
  }, {
    "heading": "",
    "content": "향상된 prune 지원: turbo prune에 대한 버그 수정 및 향상된 안정성"
  }, {
    "heading": "",
    "content": "npx @turbo/codemod migrate를 실행하여 오늘 업데이트하거나 npx create-turbo@latest로 시작하세요."
  }, {
    "heading": "새로운-터미널-ui",
    "content": "오늘까지 turbo는 라이브러리와 애플리케이션에서 작업하는 동안 로그를 스트림으로 출력했습니다. 이는 때때로 압도적일 수 있었는데, 인터리브된 로그로 인해 특정 작업에서 무슨 일이 일어나고 있는지 이해하기 어려웠기 때문입니다."
  }, {
    "heading": "새로운-터미널-ui",
    "content": "이번 릴리스를 통해 다음을 수행할 수 있는 새로운 실험적 터미널 UI를 제공합니다:"
  }, {
    "heading": "새로운-터미널-ui",
    "content": "각 작업의 로그를 전환하여 더 쉽게 따라가고 읽을 수 있습니다"
  }, {
    "heading": "새로운-터미널-ui",
    "content": "지속적인 작업과 상호 작용하여 작업의 셸에 들어가고 나가 예를 들어 단위 테스트를 다시 실행할 수 있습니다"
  }, {
    "heading": "새로운-터미널-ui",
    "content": "각 작업의 지속 시간을 막대 그래프로 확인할 수 있습니다"
  }, {
    "heading": "새로운-터미널-ui",
    "content": "새 UI를 활성화하려면 --experimental-ui 플래그를 사용하거나 turbo.json에 experimentalUI 플래그를 추가하세요:"
  }, {
    "heading": "새로운-터미널-ui",
    "content": "이 새 기능에 대한 피드백을 듣고 싶습니다. 의견을 공유하려면 GitHub Discussions의 RFC를 방문하세요."
  }, {
    "heading": "가장-빠른-기본값-활성화",
    "content": "우리는 turbo의 병렬화 및 캐싱을 넘어서 로컬 개발 경험을 가능한 한 빠르게 만들고 싶습니다."
  }, {
    "heading": "가장-빠른-기본값-활성화",
    "content": "turbo scan을 실행하면 머신을 검사하여 경험을 더 빠르게 만드는 최적화를 찾습니다."
  }, {
    "heading": "가장-빠른-기본값-활성화",
    "content": "자세한 내용은 문서를 참조하세요."
  }, {
    "heading": "가장-빠른-기본값-활성화",
    "content": "이 명령은 로컬 개발 환경용입니다. CI를 최적화하지 않습니다."
  }, {
    "heading": "ci-로깅-개선",
    "content": "이번 릴리스는 다음에서 성공적인 로그를 자동으로 그룹화하는 지원을 추가합니다:"
  }, {
    "heading": "ci-로깅-개선",
    "content": "Azure Pipelines"
  }, {
    "heading": "ci-로깅-개선",
    "content": "TeamCity"
  }, {
    "heading": "ci-로깅-개선",
    "content": "Travis CI"
  }, {
    "heading": "ci-로깅-개선",
    "content": "이러한 제공업체는 이미 지원되었던 GitHub Actions에 합류합니다."
  }, {
    "heading": "ci-로깅-개선",
    "content": "또한 Turborepo는 이제 성공적으로 완료되지 않은 작업의 그룹을 해제하여 오류가 있는 작업을 더 빨리 찾을 수 있습니다."
  }, {
    "heading": "prune에-대한-향상된-패키지-매니저-지원",
    "content": "Turborepo의 prune 명령은 Docker 사용자에게 중요한 최적화로, 모노레포에서 경량 이미지를 생성하는 데 도움이 됩니다."
  }, {
    "heading": "prune에-대한-향상된-패키지-매니저-지원",
    "content": "pnpm lockfile 지원은 작업 공간 상대 경로 참조 지원을 추가하고 .npmrc의 link-workspace-packages 속성을 준수하여 업그레이드되었습니다."
  }, {
    "heading": "prune에-대한-향상된-패키지-매니저-지원",
    "content": "Yarn4 지원은 작업 공간의 루트에서 package.json의 resolutions를 지원하여 개선되었습니다."
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo 1.12 출시 이후 놀라운 채택률과 커뮤니티 성장을 보았습니다:"
  }, {
    "heading": "커뮤니티",
    "content": "24.6k+ GitHub Stars"
  }, {
    "heading": "커뮤니티",
    "content": "주간 NPM 다운로드 2.3M+회"
  }, {
    "heading": "커뮤니티",
    "content": "Vercel Remote Cache를 사용하여 283년의 컴퓨팅 시간 절약"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo는 핵심 팀을 포함한 모든 기여자들의 노력이 결합된 결과입니다."
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo를 여러분의 빌드 도구로 선택하기 위해 지속적인 지원, 피드백, 협업에 감사드립니다."
  }],
  "headings": [{
    "id": "새로운-터미널-ui",
    "content": "새로운 터미널 UI"
  }, {
    "id": "가장-빠른-기본값-활성화",
    "content": "가장 빠른 기본값 활성화"
  }, {
    "id": "ci-로깅-개선",
    "content": "CI 로깅 개선"
  }, {
    "id": "prune에-대한-향상된-패키지-매니저-지원",
    "content": "prune에 대한 향상된 패키지 매니저 지원"
  }, {
    "id": "커뮤니티",
    "content": "커뮤니티"
  }]
};
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
import {Callout} from '#components/callout';
import {ThemeAwareImage} from '#components/theme-aware-image';
import {ExperimentalBadge} from '#components/experimental-badge';
export const toc = [{
  depth: 2,
  url: "#새로운-터미널-ui",
  title: _jsx(_Fragment, {
    children: "새로운 터미널 UI"
  })
}, {
  depth: 2,
  url: "#가장-빠른-기본값-활성화",
  title: _jsx(_Fragment, {
    children: "가장 빠른 기본값 활성화"
  })
}, {
  depth: 2,
  url: "#ci-로깅-개선",
  title: _jsx(_Fragment, {
    children: "CI 로깅 개선"
  })
}, {
  depth: 2,
  url: "#prune에-대한-향상된-패키지-매니저-지원",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "prune"
    }), "에 대한 향상된 패키지 매니저 지원"]
  })
}, {
  depth: 2,
  url: "#커뮤니티",
  title: _jsx(_Fragment, {
    children: "커뮤니티"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.13"
    }), "\n", "\n", _jsx(Date, {
      children: "Thursday, March 21st, 2024"
    }), "\n", _jsx(Authors, {
      authors: ['gregsoltis', 'chrisolszewski']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 1.13은 새롭고 개선된 로컬 개발 경험과 함께 기타 개선 사항을 제공합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#new-terminal-ui",
          children: _jsx(_components.strong, {
            children: "새로운 터미널 UI"
          })
        }), " ", _jsx(ExperimentalBadge, {}), ": 향상된 터미널 경험에서 로컬로 작업과 상호 작용"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#enable-the-fastest-defaults",
          children: _jsx(_components.strong, {
            children: "가장 빠른 기본값 활성화"
          })
        }), ": ", _jsx(_components.code, {
          children: "turbo scan"
        }), "으로 로컬 개발 환경을 더 빠르게 만들기"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#ci-logging-improvements",
          children: _jsx(_components.strong, {
            children: "CI 로깅 개선"
          })
        }), ": 4개 주요 제공업체 지원 및 오류 작업 자동 펼치기"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#enhanced-package-manager-support-for-prune",
          children: _jsxs(_components.strong, {
            children: ["향상된 ", _jsx(_components.code, {
              children: "prune"
            }), " 지원"]
          })
        }), ": ", _jsx(_components.code, {
          children: "turbo prune"
        }), "에 대한 버그 수정 및 향상된 안정성"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), "를 실행하여 오늘 업데이트하거나 ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), "로 시작하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "새로운-터미널-ui",
      children: "새로운 터미널 UI"
    }), "\n", _jsxs(_components.p, {
      children: ["오늘까지 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 라이브러리와 애플리케이션에서 작업하는 동안 로그를 스트림으로 출력했습니다. 이는 때때로 압도적일 수 있었는데, 인터리브된 로그로 인해 특정 작업에서 무슨 일이 일어나고 있는지 이해하기 어려웠기 때문입니다."]
    }), "\n", _jsx(_components.p, {
      children: "이번 릴리스를 통해 다음을 수행할 수 있는 새로운 실험적 터미널 UI를 제공합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "각 작업의 로그를 전환"
        }), "하여 더 쉽게 따라가고 읽을 수 있습니다"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "지속적인 작업과 상호 작용"
        }), "하여 작업의 셸에 들어가고 나가 예를 들어 단위 테스트를 다시 실행할 수 있습니다"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "각 작업의 지속 시간을"
        }), " 막대 그래프로 확인할 수 있습니다"]
      }), "\n"]
    }), "\n", _jsx(ThemeAwareImage, {
      className: "my-4 flex justify-center",
      light: {
        alt: 'A screenshot of a terminal running `turbo scan`.',
        src: '/images/blog/turbo-1-13-0/experimental-ui.gif',
        props: {
          width: 800,
          height: 350,
          className: 'dark:hidden block'
        }
      },
      dark: {
        alt: 'A screenshot of a terminal running `turbo scan`.',
        src: '/images/blog/turbo-1-13-0/experimental-ui.gif',
        props: {
          width: 800,
          height: 350,
          className: 'hidden dark:block'
        }
      }
    }), "\n", _jsxs(_components.p, {
      children: ["새 UI를 활성화하려면 ", _jsx(_components.code, {
        children: "--experimental-ui"
      }), " 플래그를 사용하거나 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "에 ", _jsx(_components.code, {
        children: "experimentalUI"
      }), " 플래그를 추가하세요:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"experimentalUI\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "이 새 기능에 대한 피드백을 듣고 싶습니다."
      }), " 의견을 공유하려면 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turbo/discussions/7802",
        children: "GitHub Discussions의 RFC를 방문"
      }), "하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "가장-빠른-기본값-활성화",
      children: "가장 빠른 기본값 활성화"
    }), "\n", _jsxs(_components.p, {
      children: ["우리는 ", _jsx(_components.code, {
        children: "turbo"
      }), "의 병렬화 및 캐싱을 넘어서 로컬 개발 경험을 가능한 한 빠르게 만들고 싶습니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo scan"
      }), "을 실행하면 머신을 검사하여 경험을 더 빠르게 만드는 최적화를 찾습니다."]
    }), "\n", _jsx(ThemeAwareImage, {
      className: "my-4 flex justify-center",
      light: {
        alt: 'A screenshot of a terminal running `turbo scan`.',
        src: '/images/blog/turbo-1-13-0/turbo-scan-light.png',
        props: {
          width: 934,
          height: 869,
          className: 'dark:hidden block rounded-xl border border-2'
        }
      },
      dark: {
        alt: 'A screenshot of a terminal running `turbo scan`.',
        src: '/images/blog/turbo-1-13-0/turbo-scan-dark.png',
        props: {
          width: 1868,
          height: 1800,
          className: 'hidden dark:block rounded-xl border border-2 dark:border-gray-700'
        }
      }
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/reference/scan",
        children: "문서"
      }), "를 참조하세요."]
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsx(_components.p, {
        children: "이 명령은 로컬 개발 환경용입니다. CI를 최적화하지 않습니다."
      })
    }), "\n", _jsx(_components.h2, {
      id: "ci-로깅-개선",
      children: "CI 로깅 개선"
    }), "\n", _jsx(_components.p, {
      children: "이번 릴리스는 다음에서 성공적인 로그를 자동으로 그룹화하는 지원을 추가합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Azure Pipelines"
      }), "\n", _jsx(_components.li, {
        children: "TeamCity"
      }), "\n", _jsx(_components.li, {
        children: "Travis CI"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "이러한 제공업체는 이미 지원되었던 GitHub Actions에 합류합니다."
    }), "\n", _jsx(_components.p, {
      children: "또한 Turborepo는 이제 성공적으로 완료되지 않은 작업의 그룹을 해제하여 오류가 있는 작업을 더 빨리 찾을 수 있습니다."
    }), "\n", _jsx(ThemeAwareImage, {
      className: "my-4 flex justify-center",
      light: {
        alt: "A screenshot of a GitHub Action that ran a `turbo` task. The logs for tasks that completed successfully are folded while the errored task shows it's logs in full with red highlighting.",
        src: '/images/blog/turbo-1-13-0/github-action.png',
        props: {
          width: 3306,
          height: 2607,
          className: 'dark:hidden block rounded-xl'
        }
      },
      dark: {
        alt: "A screenshot of a GitHub Action that ran a `turbo` task. The logs for tasks that completed successfully are folded while the errored task shows it's logs in full with red highlighting.",
        src: '/images/blog/turbo-1-13-0/github-action.png',
        props: {
          width: 3306,
          height: 2607,
          className: 'hidden dark:block rounded-xl'
        }
      }
    }), "\n", _jsxs(_components.h2, {
      id: "prune에-대한-향상된-패키지-매니저-지원",
      children: [_jsx(_components.code, {
        children: "prune"
      }), "에 대한 향상된 패키지 매니저 지원"]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo의 ", _jsx(_components.code, {
        children: "prune"
      }), " 명령은 Docker 사용자에게 중요한 최적화로, 모노레포에서 경량 이미지를 생성하는 데 도움이 됩니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["pnpm lockfile 지원은 ", _jsx(_components.a, {
        href: "https://pnpm.io/workspaces#referencing-workspace-packages-through-their-relative-path",
        children: "작업 공간 상대 경로 참조"
      }), " 지원을 추가하고 ", _jsxs(_components.a, {
        href: "https://pnpm.io/npmrc#link-workspace-packages",
        children: [_jsx(_components.code, {
          children: ".npmrc"
        }), "의 ", _jsx(_components.code, {
          children: "link-workspace-packages"
        }), " 속성"]
      }), "을 준수하여 업그레이드되었습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["Yarn4 지원은 작업 공간의 루트에서 ", _jsxs(_components.a, {
        href: "https://yarnpkg.com/configuration/manifest#resolutions",
        children: [_jsx(_components.code, {
          children: "package.json"
        }), "의 ", _jsx(_components.code, {
          children: "resolutions"
        })]
      }), "를 지원하여 개선되었습니다."]
    }), "\n", _jsx(_components.h2, {
      id: "커뮤니티",
      children: "커뮤니티"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/blog/turbo-1-12-0",
        children: "Turborepo 1.12"
      }), " 출시 이후 놀라운 채택률과 커뮤니티 성장을 보았습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "24.6k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "주간 NPM 다운로드 2.3M+회"
        })
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Vercel Remote Cache"
        }), "를 사용하여 283년의 컴퓨팅 시간 절약"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 핵심 팀을 포함한 모든 기여자들의 노력이 결합된 결과입니다."
    }), "\n", _jsx(_components.p, {
      children: "Turborepo를 여러분의 빌드 도구로 선택하기 위해 지속적인 지원, 피드백, 협업에 감사드립니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
